import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const ShortcutsHelpModalContainer = lazy(() => import('.'))

class ShortcutsHelpComponent extends ReactWebComponent {
  override render() {
    return (
      <RootProviders>
        <ShortcutsHelpModalContainer />
      </RootProviders>
    )
  }
}

customElements.define('shortcuts-help', ShortcutsHelpComponent)
